export const SymbolVideoIcon = () => (
	<i className="symbol symbol--video"></i>
)